import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface LandingPageErrorCSSStyle extends UIComponentCSSStyle
{
    
}

export class LandingPageErrorCSSStyleImpl extends UIComponentCSSStyleImpl implements LandingPageErrorCSSStyle
{   
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/landingpage/error/landingpageerrorcss.tsx